import { RouterManager } from '@aclass/admin/managers';
import { ExtraPricesStory } from '@aclass/admin/storage/actions';
import { IAdminState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable()
export class ExtraPricesEditStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:extra-price-edit';

    private id: number;

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<number | null>(['extraPricesModule', 'editPageRecordId']).pipe(filter(v => v === this.id));
        this.employee = this.routerManager.onRejectNavigation(ExtraPricesEditStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(route: ActivatedRouteSnapshot): void {
        this.id = parseInt(route.params.id);
        this.ngRdx.dispatch(ExtraPricesStory.dryRunEditPage(this.id));
    }
}
